
import { useState } from 'react';
import LoginForm from './components/LoginForm';
import Dashboard from './components/Dashboard';
import { loginAdmin, logoutAdmin } from '../../services/auth';

export default function AdminPage() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (email: string, password: string) => {
    setLoading(true);
    try {
      const result = await loginAdmin(email, password);
      if (result.success) {
        setIsLoggedIn(true);
        return true;
      } else {
        alert('登录失败: ' + (result.error || '请检查邮箱和密码'));
        return false;
      }
    } catch (error: any) {
      alert('登录失败: ' + error.message);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    await logoutAdmin();
    setIsLoggedIn(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-slate-100">
      {!isLoggedIn ? (
        <LoginForm onLogin={handleLogin as (username: string, password: string) => Promise<boolean>} />
      ) : (
        <Dashboard onLogout={handleLogout} />
      )}
    </div>
  );
}